import React from 'react';
import { connect } from 'react-redux';
import findResult from '@/utils/resultsHelper';
import { findError, validationClasses } from '@/utils/errors';
import fields, { globalFieldLengths } from '@/constants/fields';
import ValidationSpan from '@/components/errors/ValidationSpan';
import { updateCohortProperties } from '../actions';
import CohortFieldInput from '../components/CohortFieldInput';
import CohortFieldHeader from './CohortFieldHeader';
import { canEditCohort } from '../helper';

const CohortName = ({
  code,
  category,
  name,
  isSystem,
  isEditing,
  canEdit,
  updateName,
  validationErrors,
  errorCoordinate = 't-30',
}) => {
  const validationError = findError(validationErrors, 'cohort', [fields.NAME]);

  return (
    <>
      {!isEditing && (
        <CohortFieldHeader
          code={code}
          category={category}
          value={name}
          icon="filter"
          canEdit={canEdit}
          isSystem={isSystem}
        />
      )}
      {canEdit && isEditing && (
        <>
          <ValidationSpan validationError={validationError} position="right" errorCoordinate={errorCoordinate} />
          <CohortFieldInput
            text={name}
            type="name"
            maxLength={globalFieldLengths.name}
            onChange={(value) => updateName(category, code, value)}
            icon="filter"
            iconPosition="left"
            size="huge"
            className={validationClasses(validationError)}
          />
        </>
      )}
    </>
  );
};

const mapStateToProps = ({
  auth: { role },
  cohorts: { cohorts },
}, { category, code }) => {
  const item = findResult(cohorts, category, code);
  const isEditing = item ? item.isEditing : false;
  const validationErrors = item ? item.saveErrors : null;
  const queryAccess = item ? item.access.query_access : false;

  return (
    {
      isEditing,
      name: item?.name || '',
      isSystem: item?.system,
      canEdit: item ? canEditCohort(item, role) && queryAccess : false,
      validationErrors,
    }
  );
};

const mapDispatchToProps = {
  updateName: (category, code, value) => updateCohortProperties(category, code, { name: value }),
};

export default connect(mapStateToProps, mapDispatchToProps)(CohortName);
